(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningDeleteController',GroupePlanningDeleteController);

    GroupePlanningDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupePlanning'];

    function GroupePlanningDeleteController($uibModalInstance, entity, GroupePlanning) {
        var vm = this;

        vm.groupePlanning = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupePlanning.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
